import type { CSSProperties, ReactNode } from 'react';
import { cx } from '@parrot/utils';
import styles from './ChartLegend.module.css';

export interface ChartLegendItem {
  label: string;
  /** Series colour — a token or a resolved colour. */
  color: string;
  /** Square for bars / areas, line for line series, dash for reference lines,
      hatch for "not available" fills, dot for point markers. */
  shape?: 'square' | 'line' | 'dash' | 'hatch' | 'dot';
}

export interface ChartLegendProps {
  items: ChartLegendItem[];
  /** A muted aside after the keys ("Bar height = total catalogue"). */
  note?: ReactNode;
  /** 'below' (default): centred under the plot. 'header': right-aligned in a card header. */
  placement?: 'below' | 'header';
  className?: string;
}

/** Chart legend: coloured keys plus an optional note. */
export function ChartLegend({ items, note, placement = 'below', className }: ChartLegendProps) {
  return (
    <div className={cx(styles.legend, styles[placement], className)} aria-hidden="true">
      {items.map((item) => (
        <span key={item.label} className={styles.item}>
          <span
            className={cx(styles.swatch, styles[item.shape ?? 'square'])}
            style={{ '--color': item.color } as CSSProperties}
          />
          {item.label}
        </span>
      ))}
      {note && <span className={styles.note}>{note}</span>}
    </div>
  );
}
